import { render, staticRenderFns } from "./ShopShopIndustry.vue?vue&type=template&id=0fd15a8f&scoped=true&"
import script from "./ShopShopIndustry.vue?vue&type=script&lang=js&"
export * from "./ShopShopIndustry.vue?vue&type=script&lang=js&"
import style0 from "./ShopShopIndustry.vue?vue&type=style&index=0&id=0fd15a8f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd15a8f",
  null
  
)

export default component.exports